const actions = {
  SET_LEADS_TABLE_DATA: 'SET_LEADS_TABLE_DATA',
  SET_LEADS_WIDGET_DATA: 'SET_LEADS_WIDGET_DATA',
  SET_LEADS_WIDGET_FILTER: 'SET_LEADS_WIDGET_FILTER',
  SET_LEADS_PLATFORM_FILTER: 'SET_LEADS_PLATFORM_FILTER',
  SET_EMAIL_LEADS_DATA: 'SET_EMAIL_LEADS_DATA',
};

export default actions;
